import { jsx as _jsx } from "react/jsx-runtime";
import React, {} from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { Box } from '@famly/mf_layout_box';
let loadedReactMarkdown;
const loadReactMarkdown = () => import('react-markdown').then(module => {
    loadedReactMarkdown = module.default;
    return module;
});
const LazyReactMarkdown = React.lazy(loadReactMarkdown);
/**
 * Fetches the markdown renderer, so a dialog opened afterwards renders its description formatted
 * straight away instead of showing the raw text while the renderer loads.
 */
export const preloadMarkdownDescription = () => loadReactMarkdown().then(() => undefined, () => {
    // Best effort: a dialog opened later loads the renderer again, or shows the raw text.
});
/**
 * Renders a dialog description as markdown. No dialog opens before the app first renders, so the
 * renderer stays out of the startup bundle; until it is loaded, or if it cannot load, the raw text
 * keeps the description readable.
 */
export const MarkdownDescription = ({ children }) => {
    const ReactMarkdown = loadedReactMarkdown !== null && loadedReactMarkdown !== void 0 ? loadedReactMarkdown : LazyReactMarkdown;
    const rawText = _jsx(Box, { component: "p", children: children });
    return (_jsx(ErrorBoundary, { fallback: rawText, children: _jsx(React.Suspense, { fallback: rawText, children: _jsx(ReactMarkdown, { children: children }) }) }));
};
